<script>
import { ref } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import 'vue3-carousel/carousel.css';

import Auth from "./../../auth/auth.js";
import NavBar from "./../../components/NavBar.vue";

import HowItWorksView from "./HowItWorksView.vue";

import USCLogo from "@/assets/images/USC.png";
// import StanfordLogo from "@/assets/images/STANFORD.png";
import HarvardLogo from "@/assets/images/HARVARD.png";
// import CalTechLogo from "@/assets/images/CALTECH.png";
// import UPennLogo from "@/assets/images/UPENN.png";
// import RiceLogo from "@/assets/images/RICE.png";
import MITLogo from "@/assets/images/MIT.png";
import PennStateLogo from "@/assets/images/PENN_STATE.png";
import DeAnzaLogo from "@/assets/images/DeAnza.png";

const API_BASE = process?.env?.VUE_APP_API_BASE_URL ?? '/api';

const colleges = ref([]);
const collegeLogos = [
  { src: USCLogo, alt: "USC", numCounselors: 5, collegeName: "University of Southern California"},
  // { src: StanfordLogo, alt: "Stanford", numCounselors: 5, collegeName: "Stanford University"},
  { src: HarvardLogo, alt: "Harvard", numCounselors: 5, collegeName: "Harvard University"},
  // { src: CalTechLogo, alt: "CalTech", numCounselors: 5, collegeName: "California Institute of Technology"},
  // { src: UPennLogo, alt: "UPenn", numCounselors: 5, collegeName: "University of Pennsylvania"},
  // { src: RiceLogo, alt: "Rice", numCounselors: 5, collegeName: "Rice University"},
  { src: MITLogo, alt: "MIT", numCounselors: 5, collegeName: "Massachusetts Institute of Technology"},
  { src: DeAnzaLogo, alt: "De Anza", numCounselors: 5, collegeName: "DeAnza College"},
  { src: PennStateLogo, alt: "Penn State", numCounselors: 5, collegeName: "Penn State University"},
];

export default {
  name: "HomePage",
  components: {
    NavBar,
    Carousel,
    Slide,
    Navigation,
    HowItWorksView
  },
  data() {
    return {
      msg: "",
      header: "",
      isHovered: null, // Keeps track of the currently hovered university
      collegeId: "",
      helpType: "",
      colleges, // sort by name
      collegeLogos,
    };
  },
  methods: {
    handleMouseOver(universityName) {
      this.isHovered = universityName; // Set the hovered university name
    },
    handleMouseLeave() {
      this.isHovered = null; // Reset the hovered university when the mouse leaves
    },
    isAuthenticated() {
      return Auth.isAuthenticated();
    },
    setHelpType(filter) {
      this.helpType = filter;
    },
    setCollegeId(id) {
      this.collegeId = id;
    },
    search() {
      const baseUrl = "https://collegegenius.netlify.app/browse-counselors";

      // Default to "-1" if no collegeId is selected
      const cId = this.collegeId || -1;
      // If helpType is empty, set it to an empty string; otherwise use the selected helpType
      const type = this.helpType || "";

      // Construct all query params
      const searchParams = new URLSearchParams({
        names: "",
        college_id: cId,
        help_type: type,
        is_online: false,
        min_rating: 0
      });

      window.location.href = `${baseUrl}?${searchParams.toString()}`;
    },
    goToBrowse(collegeName) {
      console.log("Colleges: " + this.colleges); // prints the array of colleges to console
      console.log("College Name: " + collegeName);   // prints the name passed into the function
      const selectedCollege = this.colleges.find(
        (college) => college.title.toLowerCase() === collegeName.toLowerCase()
      );

      const collegeId = selectedCollege ? selectedCollege.id : -1;

      const baseUrl = "https://collegegenius.netlify.app/browse-counselors";
      const searchParams = new URLSearchParams({
        names: "",
        college_id: collegeId,
        help_type: "",
        is_online: false,
        min_rating: 0,
      });

      window.location.href = `${baseUrl}?${searchParams.toString()}`;
    },
  },
  async mounted() {
    // fetch colleges through proxy
    try {
      let res = await fetch(`${API_BASE}/colleges`, {
        method: "GET",
      });
      let data = await res.json();
      data.colleges.sort((a, b) => a.title.localeCompare(b.title)); // sort alphanumerically, A-Z
      colleges.value = data.colleges;
      console.log("College List with values:", colleges.value);

    } catch (error) {
      console.error(error);
    }
  },
};
</script>

<style>
/* START OF POTENTIAL FUCK UP */
:root {
  --secondary: #3867ae;
  --primary: #ffd966;
}

.main-section-title {
  text-align: center;
  font-size: 30px;
  color: #333;
  margin-bottom: 20px;
  margin-top: 60px;
}

.main-banner-hero {
  padding-top: 200px;
  text-indent: 0;
}

.main-banner-hero__text p {
  font-size: 1.4rem;
  line-height: 1.6;
  font-family: Trebuchet MS, sans-serif;
}
.main-banner-hero p:before{
  content: none !important;
}

.search-widget__card {
  display: flex;
  max-width: 600px;
  margin-top: 1rem;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
}

.search-widget__option {
  flex: 1;
}

.search-widget__options {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex: 1;
}

.search-widget__option select {
  border: none;
}

.search-widget__button {
  background-color: #ffd966;
  color: #1d2a57;
  font-weight: bold;
  padding: 1rem 1.5rem;
  cursor: pointer;
  font-size: 1rem;
  white-space: nowrap;
  border-left: 1px solid #ccc;
}

.TurnCollegeDreams {
  text-align: center;
  padding: 20px;
  margin-top: 30px;
}

.main-counters-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 20px 0;
}

.main-counters__item {
  text-align: center;
  flex: 1;
  max-width: 360px;
  padding: 0 10px;
}

.main-counters__item-ico img {
  width: 80px;
  height: auto;
  margin-bottom: 10px;
}

.main-counters__item h1.counter {
  font-size: 38px;
  color: var(--secondary);
  font-weight: bold;
  margin-top: 10px;
}

.main-counters__item p {
  font-size: 15px;
  color: #444;
  line-height: 1.6;
}

.capability__list {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 20px 0;
}

.capability__item {
  text-align: center;
  max-width: 300px;
  padding: 10px;
}

.capability__item h3 {
  font-size: 26px;
  color: var(--secondary);
  margin-top: 20px;
}

.capability__item p {
  font-size: 18px;
  color: #444;
  margin-top: 1rem;
  line-height: 1.6;
}

.capability__item-picture img {
  width: 100%;
  height: auto;
  border-radius: 10px;
}

.section-spacing {
  margin-top: 40px; /* Adds space between sections */
}

.TurnCollegeDreams h2 {
  color: #000; /* Sets the text color to black */
  font-size: 30px;
}

/* --- Base navigation button styles --- */
.carousel__prev,
.carousel__next {
  color: #ccc; /* arrow color (light gray) */
  background: rgba(0, 0, 0, 0.3); /* subtle dark translucent bg */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  transition:
    background 0.3s ease,
    color 0.3s ease,
    transform 0.25s ease,
    box-shadow 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* --- Hover state --- */
.carousel__prev:hover,
.carousel__next:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  box-shadow: 0 0 12px rgba(255, 255, 255, 0.4);
  opacity: 1;
}

/* --- Active/pressed state --- */
.carousel__prev:active,
.carousel__next:active {
  background: rgba(255, 255, 255, 0.25);
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.2);
}

/* --- Optional: make sure arrows sit above content --- */
.carousel__prev,
.carousel__next {
  z-index: 10;
}


.hover-overlay {
  position: absolute;
  inset: 0; /* covers entire image */
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 2;
  border-radius: 6px;
}

.hover-text-container {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 4px; /* small space between lines */
}

.hover-text {
  display: block;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: #fff;
  font-size: 15px;
  transform: translateY(10px);
  opacity: 0;
  transition: all 0.4s ease;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
}

.multCounselors {
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.5px;
  transform: translateY(10px);
  opacity: 0;
  transition: all 0.4s ease;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
}

.logo-wrapper:hover .hover-overlay {
  opacity: 1;
}

.logo-wrapper:hover .hover-text {
  transform: translateY(0);
  opacity: 1;
}

.college-name {
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
}

.counselor-count {
  font-size: 16px;
  font-weight: 400;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
  /* opacity: 0.9; */
}

</style>


<template>
  <div>
    <template v-if="isAuthenticated()">
      <NavBar />
    </template>
    <template v-else>
      <NavBar />
    </template>
    <main class="main">
      <section class="main-banner main-banner-hero">
        <div class="main-banner-hero__container">
          <div class="main-banner-hero__text">
            <h1>Genius Advice from the Best Students in the Country.</h1>
            <p>1-on-1 video call students attending Ivy Leagues and Top-50
              colleges for 24/7 college assistance. No matter your college
              goals, we’re here to help your ace test preparation, college
              applications, and more at affordable prices. Now, that’s Genius!
            </p>
          </div>
          <div class="main-banner-hero__search">
            <div class="search-widget">
              <div class="search-widget__title">Find Counselors</div>
              <div class="search-widget__card">
                <ul class="search-widget__options">
                  <!-- commented out, stakeholder slides removed this -->
                  <!--
                  <li class="search-widget__option">
                    <select
                      v-model="collegeId"
                      class="form-select"
                      aria-label="Select College..."
                    >
                      <option value="">Select College...</option>
                      <option
                        v-for="college in colleges"
                        :key="college.id"
                        :value="college.id"
                      >
                        {{ college.title }}
                      </option>
                    </select>
                  </li>
                  -->
                  <li class="search-widget__option">
                    <select
                      v-model="helpType"
                      class="form-select"
                      aria-label="Select Help Type..."
                    >
                      <option value="">Find counselors who specialize in...</option>
                      <option value="test_prep">Standardized Tests</option>
                      <option value="college_applications">
                        College Applications
                      </option>
                      <option value="financial_aid">Financial Aid</option>
                      <option value="interview_prep">Interview Prep</option>
                      <option value="general_info">General School Info</option>
                    </select>
                  </li>
                </ul>
                <div class="search-widget__button" @click="search">Search</div>
              </div> 
            </div>
          </div>
          <div class="main-banner-hero__img">
            <img
              src="@/assets/images/students.png"
              alt="College Advice at a Genius Price."
            />
          </div>
        </div>
      </section>

      <!-- University Carousel Section -->
      <div class="main-section-title">Counselors from</div>
      <div class="section-spacing" style="max-width: 90%; margin: 0 auto;">
        <Carousel
          :itemsToShow="5"
          :itemsToScroll="1"
          :wrapAround="true"
          :autoplay="2500"
        >
          <Slide
            v-for="(logo, index) in collegeLogos"
            :key="index"
          >
            <div 
              class="logo-wrapper"
              @click="goToBrowse(logo.collegeName)"
              style="cursor: pointer;"
            >
              <img
                :src="logo.src"
                :alt="logo.alt"
                style="height: 75px; object-fit: contain; margin: 0 auto;"
              />
              <div class="hover-overlay">
                <div class="hover-text-container">
                  <span class="hover-text college-name">
                    {{ logo.alt }}
                  </span>
                  <span class="hover-text counselor-count">
                    {{ logo.numCounselors }} {{ Number(logo.numCounselors) === 1 ? 'Counselor' : 'Counselors' }}
                  </span>
                </div>
              </div>
            </div>
          </Slide>
          <template #addons>
            <Navigation />
          </template>
        </Carousel>
      </div>


      <div class="whycollegegenius section-spacing">
        <h2 class="main-section-title">Why Use College Genius?</h2>
        <div class="capability__list">
          <div class="capability__item">
            <picture class="capability__item-picture">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR3bzf9Ea_0qoJvFdKhQqwuboU2VhdRESbs2A&s"
                alt="Student Advice"
              />
            </picture>
            <h3>Top Tier Talent</h3>
            <p>
              Vetted students who recently and successfully went through the application process themselves 
              are helping students everyday submit a top notch, acceptance-worthy application.
            </p>
          </div>
          <div class="capability__item">
            <picture class="capability__item-picture">
              <img
                src="https://t3.ftcdn.net/jpg/03/16/88/66/360_F_316886630_2ebvLNaZWiwUDNUoxEZ7HDBI0GCwgDZZ.jpg"
                alt="3x Less Expensive"
              />
            </picture>
            <h3>3x More Affordable</h3>
            <p>
              While average private college counseling ranges upward of $250 an hour, 
              College Genius counselors starts is just  $50 per hour and offers experience-based 
              knowledge that supersedes antiquated counseling. 
            </p>
          </div>
          <div class="capability__item">
            <picture class="capability__item-picture">
              <img
                src="https://www.meredith.edu/wp-content/uploads/2022/12/Meredith-Student-Advice_hero.jpg"
                alt="Specific Matching"
              />
            </picture>
            <h3>Instant-Counseling</h3>
            <p>
              Connect with an online counselor in minutes, 24/7. Whether you 
              have just one question, or are looking for weekly 3 hour sessions. 
              Whatever your need, we cater to you.
            </p>
          </div>
        </div>
        <div class="TurnCollegeDreams">
          <h2>Turn your college dreams into reality like so many others.</h2>
          <div class="main-counters-container">
            <div class="main-counters__item">
              <div class="main-counters__item-ico">
                <img
                  src="https://www.appreciationatwork.com/wp-content/uploads/2017/05/30344849_l.jpg"
                  alt="Acceptance Rate Icon"
                />
              </div>
              <h1 class="counter">91%</h1>
              <p>of clients are accepted to at least 3 of their top 5 choices</p>
            </div>
            <div class="main-counters__item">
              <div class="main-counters__item-ico">
                <img
                  src="https://urge.org/wp-content/uploads/2021/09/college-folk-854x480.jpg"
                  alt="Registered Students Icon"
                />
              </div>
              <h1 class="counter">53,997</h1>
              <p>students have registered to College Genius</p>
            </div>
            <div class="main-counters__item">
              <div class="main-counters__item-ico">
                <img
                  src="https://www.usc.edu/wp-content/uploads/2023/03/48244572917_c36112db94_o-1-scaled.jpg"
                  alt="Counselors Icon"
                />
              </div>
              <h1 class="counter">6760+</h1>
              <p>vetted counselors attending Ivy Leagues and Top-50 Colleges</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
  <HowItWorksView />
</template>